/* eslint-disable camelcase */
import type { BasketCheckoutButtonModel } from 'autogen/swagger/all';
import { GoToCheckout, GoToCheckoutMobile } from 'autogen/translation-keys/trans-website-basket';
import { ButtonWithIcon } from 'components/Button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { hideOnDesktop, hideOnMobile } from 'components/pages/Checkout/components/Delivery/shared/styles';
import BasketPowerstepOpener from 'components/basket/BasketPowerstep/BasketPowerstepOpener';
import dynamic from 'helpers/dynamic';
import LinkActionButton from 'components/Button/LinkActionButton';
import BasketCheckoutMessagesButton from './BasketCheckoutButton/BasketCheckoutMessagesButton';
import BasketCheckoutNotAuthenticatedButton from './BasketCheckoutButton/BasketCheckoutNotAuthenticatedButton';
import Icon from 'components/Icon';

const StyledButtonWithIcon = styled(LinkActionButton.WithIcon)`
    flex: 2;
`;

export default function BasketCheckoutButton({ model }: { model: BasketCheckoutButtonModel }) {
    const { isEnabled, linkAction, requireLogin, messages } = model;
    const { t } = useTranslation();

    const isPowerstepTwo = messages.find((message) => message.messageType === 'PowerstepTwo');
    const hasBasketMessages = messages.length;

    const text = (
        <>
            <span css={hideOnMobile}>{t(GoToCheckout)}</span>
            <span css={hideOnDesktop}>{t(GoToCheckoutMobile)}</span>
        </>
    );

    if (requireLogin) {
        return <BasketCheckoutNotAuthenticatedButton model={model}>{text}</BasketCheckoutNotAuthenticatedButton>;
    }

    if (isPowerstepTwo) {
        return <BasketPowerstepOpener checkoutLinkAction={linkAction} />;
    }

    if (hasBasketMessages) {
        return <BasketCheckoutMessagesButton model={model}>{text}</BasketCheckoutMessagesButton>;
    }

    return (
        <StyledButtonWithIcon
            disabled={!isEnabled}
            icon={<Icon type="ChevronRight" size={16} />}
            size="lg"
            iconProperties={{ position: 'right' }}
            action={linkAction}
        >
            {text}
        </StyledButtonWithIcon>
    );
}
